module.exports = __webpack_public_path__ + "img/660505_F2B090_DD4D37_AA1914-256px.ee9ac4f3.png";